import { BehaviorSubject } from 'rxjs';

const ThrottleModalSubject = new BehaviorSubject(false);

const ThrottleModalStore = {
  update: value => {
    ThrottleModalSubject.next(value);
  },
  subscribe: setState => ThrottleModalSubject.subscribe(setState),
  getValue: () => ThrottleModalSubject.value,
};

export { ThrottleModalStore };
